import { Label, useTheme, type Theme } from '@shared/components';

export type ExamEventTypeLabelVariants = 'in-house' | 'public';

export const EXAM_EVENT_TYPE_TEXT: Readonly<Record<ExamEventTypeLabelVariants, string>> = {
  'in-house': 'In-house',
  public: 'Public',
};

interface ExamEventTypeLabelProps {
  variant: ExamEventTypeLabelVariants;
}

function getExamEventTypeStyles(theme: Theme) {
  return {
    colors: {
      'in-house': 'hsla(20, 90%, 37%, 1)',
      public: theme.palette.success.main,
    },
    backgroundColors: {
      'in-house': 'hsla(43, 96%, 89%, 1)',
      public: theme.palette.success.lighter,
    },
    borderColors: {
      'in-house': 'hsla(32, 92%, 50%, 1)',
      public: theme.palette.success.main,
    },
  };
}

export default function ExamEventTypeLabel(props: Readonly<ExamEventTypeLabelProps>) {
  const { variant } = props;

  const theme = useTheme();

  const { backgroundColors, borderColors, colors } = getExamEventTypeStyles(theme);

  return (
    <Label
      variant='outlined'
      size='small'
      sx={{
        borderColor: borderColors[variant],
        bgcolor: backgroundColors[variant],
        color: colors[variant],
      }}
      borderType='round'
    >
      {EXAM_EVENT_TYPE_TEXT[variant]}
    </Label>
  );
}
